import baseAPI from '@/http'

const router = 'api/salaindicadores'

export const salaIndicadoresApi = {
  create: (indicador) => baseAPI.post(router, indicador),
  update: (indicador) => baseAPI.put(router, indicador),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listNiveis: () => baseAPI.get('api/salaindicadornivel'),
  listApuracao: () => baseAPI.get('api/salaindicadorapuracao'),
  listLeitura: () => baseAPI.get('api/salaindicadorleitura'),
  listFonte: () => baseAPI.get('api/salaindicadorfonte'),
  listUnidade: () => baseAPI.get('api/salaindicadoresunidade')
}
